export default {
  install(Vue, { store }) {
    Vue.prototype.$canAccess = (allowedRoles = [], deniedRoles = []) => {
      const userType = store.getters['user/type']

      // Verifică dacă utilizatorul se află în lista rolurilor permise
      const isPermitted = allowedRoles.length === 0 || allowedRoles.includes(userType)
      // Verifică dacă utilizatorul nu se află în lista rolurilor interzise
      const isDenied = deniedRoles.includes(userType)

      // Returnează true dacă este permis și nu este interzis
      return isPermitted && !isDenied
    }

    Vue.prototype.$isAgency = () => {
      const userType = store.getters['user/type']
      const parentType = store.state.user.parent_user

      if (['employee', 'agency-employee', 'brand-employee'].includes(userType)) {
        return parentType && parentType.slug === 'agency'
      }

      return userType === 'agency'
    }

    Vue.prototype.$isTopBrandAdmin = () => {
      const userType = store.getters['user/type']
      const parentType = store.state.user.parent_user

      const isBrandAdmin = userType === 'brand-admin' && parentType === null
      const isTrafficManagerFromParent = parentType?.type === 'traffic-manager'
      const isBrandEmployee = userType === 'brand-employee' && parentType === null
      const isTrafficManagerFromGrandParent = parentType?.parent_type === 'traffic-manager'
      const isTopBrandAdmin = isBrandAdmin || isTrafficManagerFromParent || isBrandEmployee || isTrafficManagerFromGrandParent

      return isTopBrandAdmin
    }

    Vue.prototype.$hasPublisher = () => {
      const publishers = store.getters['user/publishers']

      if (publishers && publishers?.length > 0) {
        return true
      }

      return false
    }

    Object.defineProperty(Vue.prototype, '$is_impersonate', {
      get() {
        return store.getters['user/is_impersonate'] || false
      },
    })

    Object.defineProperty(Vue.prototype, '$is_PM', {
      get() {
        const userType = store.getters['user/type']
        // PD-4056: 'admin' gets Project Manager parity for Social Boost by AC.
        return userType === 'project-manager' || userType === 'admin'
      },
    })

    Object.defineProperty(Vue.prototype, '$is_GD', {
      get() {
        const userType = store.getters['user/type']
        return userType === 'graphic-designer'
      },
    })
  },
}
